import React from 'react';
import { Flex, Button, NumericInput } from '@leverege/ui-elements';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function TableFooter({
  pageIndex,
  pageSize,
  canNextPage,
  canPreviousPage,
  setPageSize,
  gotoPage
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    justify: "space-between",
    align: "center",
    style: {
      padding: '10px'
    },
    children: [/*#__PURE__*/_jsxs(Flex, {
      align: "center",
      children: [/*#__PURE__*/_jsx("span", {
        children: "Rows:"
      }), /*#__PURE__*/_jsx(NumericInput, {
        value: pageSize,
        onChange: value => setPageSize(Number(value.value)),
        min: 1,
        style: {
          margin: '0 8px'
        }
      })]
    }), /*#__PURE__*/_jsxs(Flex, {
      variant: "rowS",
      align: "center",
      children: [/*#__PURE__*/_jsx(Button, {
        variant: "secondary",
        icon: "fak fa-lv-chevron-left-small",
        onClick: () => gotoPage(pageIndex - 1),
        disabled: !canPreviousPage
      }), /*#__PURE__*/_jsx(Button, {
        variant: "secondary",
        icon: "fak fa-lv-chevron-right-small",
        onClick: () => gotoPage(pageIndex + 1),
        disabled: !canNextPage
      })]
    })]
  });
}
export default TableFooter;